import { render, staticRenderFns } from "./caretaker-select.vue?vue&type=template&id=24cb726e&"
import script from "./caretaker-select.vue?vue&type=script&lang=ts&"
export * from "./caretaker-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports